// 🔧 user_defaults.js
// ✅ Purpose: Creates Firestore user documents for LGV Demo Engine events
// ✅ Features:
// - Builds consistent demo event user documents
// - Separates Firestore document structure from generation logic
// - Supports Manager and Voter roles
// - Future-ready for Judges, Volunteers, Sponsors, Vendors, and Ticket Holders
// - Fully block-commented for clarity and future devs

import {
  serverTimestamp,
} from "firebase/firestore";

export const buildDemoUserDoc = ({
  generatedUser,
  displayOrder = 1,
} = {}) => {
  return {
    firstName: generatedUser.firstName,
    lastName: generatedUser.lastName,
    displayName: generatedUser.displayName,

    email: generatedUser.email,

    role: generatedUser.role,

    participantType:
      generatedUser.participantType || "Voter",

    demoIndustry:
      generatedUser.industryKey || "other",

    active: true,

    demoSeed: true,

    displayOrder,

    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
  };
};
